const AUDITOR_ROLES = {
  AUDITOR_ADMIN: 'AUDITOR_ADMIN',
  CHIEF_AUDITOR: 'CHIEF_AUDITOR',
  AUDITOR: 'AUDITOR',

}

const BANK_ROLES = {
  ADMIN: 'ADMIN',
  CHIEF_USER: 'CHIEF_USER',
  USER: 'USER',
}

const ROLES = {
  SYS_ADMIN: 'SYS_ADMIN',
  ...AUDITOR_ROLES,
  ...BANK_ROLES,
}

export { ROLES, AUDITOR_ROLES, BANK_ROLES };
